import './App.css';
import logo from './logo.jpg';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Midnight Boat Ride</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <p>The Beginning drops April 11th, 2025!</p>
      </header>
    </div>
  );
}

export default App;
